import "./MobileRangeDatePicker.scss"
import {connect} from "react-redux";
import React, {useEffect, useState} from "react";
import {Calendar, CalendarProvider} from "zaman";
import snippets from "../../../helpers/snippets";
import colors from "../../../assets/scss/variable/color.scss"

const MobileRangeDatePicker = (props) =>{
    const [language] = useState(props.language)
    const [start, setStart] = useState(0)
    const [finish, setFinish] = useState(0)

    useEffect(() => {
        let s, f
        if (!snippets.isObjectEmpty(props.defaultValue.selectedFilterName) && props.defaultValue?.selectedFilter.datepickerFrom <= 0){
            s = new Date().setDate(new Date().getDate() + props.defaultValue?.selectedFilter.datepickerFrom)
            f = new Date().setDate(new Date().getDate())
        }  else if(props.defaultValue?.selectedCustomRangeFilter && typeof props.defaultValue?.selectedCustomRangeFilter.datepickerFrom === 'string' ){
            s =  new Date(props.defaultValue?.selectedCustomRangeFilter.datepickerFrom).valueOf()
            f =  new Date(props.defaultValue?.selectedCustomRangeFilter.datepickerTo).valueOf()
        }
        setStart(s)
        setFinish(f)
    }, [props.defaultValue]);

    const changeDateHandler = (s, t) => {
        props.changedRange(s,t)
    }

    const cal = () => {
        //this function needed because this calendar does not update propped From and To !!
        return !(start && finish) ? "" : <CalendarProvider //className={styles.range_calendar}
                                                           locale={language}
                                                           direction={language === "en" ? "ltr" : "rtl"}
                                                           round="x4"
                                                           accentColor={colors.primary}>
            <Calendar
                defaultValue={start}
                onChange={({ from, to }) => changeDateHandler(from, to)}
                weekends={[6]}
                from={start}
                to={finish}
                range
            />
        </CalendarProvider>
    }

    return  cal()
}

const mapStateToProps = state => {
    const calendar = state.CalendarReducer.type;
    const language = state.LangReducer.language;
    return {calendar, language};
};

export default connect(mapStateToProps)(MobileRangeDatePicker);